<app-modal id="author-profile-cta" [maskClose]="false">
    <aside class="modal confirm-modal">
      <div class="modal-body">
        <div class="header flex">
            <div class="flex-grow-1"></div>
            <div class="button regular close" (click)="cancel()"><span class="icon">&#x00D7;</span></div>
        </div>
        <div class="content flex" >
            <div class="flex flex-direction-column">
                <h3>Complete Your Author Profile<span class="beta">BETA</span></h3>
                <p>
                    Tell us more about YOU! By completing your author profile, you'll 
                    unlock new opportunities and get tailored support that fit your needs. 
                    Together, we'll plot your success.
                </p>
                <div class="footer">
                    <button (click)="goToAuthorProfile()" class="btn btn-primary">Unlock My Profile</button>
                    <a (click)="cancel()">No Thanks, I'll do it later</a>
                </div>
            </div>
            <img src="../../../../assets/img/account/profile/kid.png" alt="Author Profile CTA" />
        </div>
      </div>
    </aside>
    <div class="confirm-modal-background"></div>
</app-modal>
